exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".app-font-size-15 {\n  font-size: 15px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/tnt_control/component/mobile_app/all/mobile_app.all.scss
// module id = 1158
// module chunks = 1